import React from 'react'

const Playlist: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/playlist.svg" alt="playlist"/>
  )
}

export default Playlist